import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b0e5d35"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card-body py-3" }
const _hoisted_2 = {
  class: "modal-header",
  id: "kt_modal_new_address_header"
}
const _hoisted_3 = { class: "modal-body py-10 px-lg-17" }
const _hoisted_4 = {
  class: "me-n7 pe-7",
  id: "kt_modal_new_address_scroll"
}
const _hoisted_5 = { class: "row mb-5" }
const _hoisted_6 = { class: "col-md-6 fv-row" }
const _hoisted_7 = { class: "form-label required" }
const _hoisted_8 = { class: "fv-plugins-message-container" }
const _hoisted_9 = { class: "fv-help-block" }
const _hoisted_10 = { class: "col-md-6 fv-row" }
const _hoisted_11 = { class: "form-label" }
const _hoisted_12 = { class: "row mb-5" }
const _hoisted_13 = { class: "col-md-6 fv-row" }
const _hoisted_14 = { class: "required fs-5 fw-bold mb-2" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "col-md-6 fv-row" }
const _hoisted_18 = { class: "fs-5 fw-bold mb-2" }
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "row mb-5" }
const _hoisted_22 = { class: "col-md-4 fv-row" }
const _hoisted_23 = { class: "required fs-5 fw-bold mb-2" }
const _hoisted_24 = {
  key: 0,
  class: "col-md-8 fv-row"
}
const _hoisted_25 = { class: "required fs-5 fw-bold mb-2" }
const _hoisted_26 = { class: "fv-plugins-message-container" }
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = { class: "d-flex flex-column mb-5 fv-row" }
const _hoisted_29 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_30 = { class: "row mb-5" }
const _hoisted_31 = { class: "col-md-12 fv-row" }
const _hoisted_32 = { class: "fs-6 fw-bold mb-2" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cloud-upload fs-5x text-primary p-2" }, null, -1))
const _hoisted_34 = { class: "el-upload__text align-middle" }
const _hoisted_35 = { class: "el-upload__tip pt-1" }
const _hoisted_36 = { class: "modal-footer flex-center" }
const _hoisted_37 = {
  ref: "submitButtonRef",
  type: "submit",
  id: "kt_modal_new_address_submit",
  class: "btn btn-primary"
}
const _hoisted_38 = { class: "indicator-label" }
const _hoisted_39 = { class: "indicator-progress" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Field = _resolveComponent("Field")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_vue_editor = _resolveComponent("vue-editor")!
  const _component_el_progress = _resolveComponent("el-progress")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([_ctx.widgetClasses, "card"])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Form, {
        class: "form",
        id: "kt_modal_new_address_form",
        onSubmit: _ctx.submit,
        "validation-schema": _ctx.validationSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("h2", null, _toDisplayString(_ctx.t("course.addCourse")), 1)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.t("course.subject")), 1),
                  _createVNode(_component_el_form_item, { prop: "matiere" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.course.subject,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.course.subject) = $event)),
                        placeholder: _ctx.t('course.chooseSubject'),
                        name: "matiere",
                        as: "select"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, { value: "" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("course.chooseSubject")) + "...", 1)
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modules, (module) => {
                            return (_openBlock(), _createBlock(_component_el_option_group, {
                              key: module.name,
                              label: module.name
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(module.subjects, (subject) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: subject._id,
                                    label: subject.name,
                                    value: subject._id
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(subject.name), 1)
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["label"]))
                          }), 128)),
                          (_ctx.subjects.length != 0)
                            ? (_openBlock(), _createBlock(_component_el_option_group, {
                                key: 0,
                                label: _ctx.t('course.others')
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subjects, (subject) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: subject._id,
                                      label: subject.name,
                                      value: subject._id
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(subject.name), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["label", "value"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["label"]))
                            : _createCommentVNode("", true)
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"]),
                      _createVNode(_component_Field, {
                        type: "hidden",
                        modelValue: _ctx.course.subject,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.course.subject) = $event)),
                        name: "subject"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(_component_ErrorMessage, { name: "subject" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.t("notes.trimester")), 1),
                  _createVNode(_component_el_form_item, { prop: "trimester" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.course.trimester,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.course.trimester) = $event)),
                        placeholder: _ctx.t('notes.chooseTrimester'),
                        name: "trimester",
                        as: "select"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: `${_ctx.t('notes.trimester')} 1`,
                            value: "1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("1")
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_option, {
                            label: `${_ctx.t('notes.trimester')} 2`,
                            value: "2"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("2")
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_option, {
                            label: `${_ctx.t('notes.trimester')} 3`,
                            value: "3"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("3")
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("label", _hoisted_14, _toDisplayString(_ctx.t("course.title")), 1),
                  _createVNode(_component_Field, {
                    type: "text",
                    class: "form-control form-control-solid",
                    placeholder: _ctx.t('course.chooseTitle'),
                    name: "title",
                    modelValue: _ctx.course.title,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.course.title) = $event))
                  }, null, 8, ["placeholder", "modelValue"]),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _createVNode(_component_ErrorMessage, { name: "title" })
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("course.module")), 1),
                  _createVNode(_component_Field, {
                    type: "text",
                    class: "form-control form-control-solid",
                    placeholder: _ctx.t('course.chooseTitle'),
                    name: "module",
                    modelValue: _ctx.course.module,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.course.module) = $event))
                  }, null, 8, ["placeholder", "modelValue"]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createVNode(_component_ErrorMessage, { name: "module" })
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_21, [
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.t("course.specificFor")), 1),
                  _createVNode(_component_el_form_item, { prop: "spec" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.spec,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.spec) = $event)),
                        name: "spec",
                        as: "select",
                        onChange: _cache[6] || (_cache[6] = ($event: any) => (_ctx.clearStudents()))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_option, {
                            label: _ctx.t('course.allStudent'),
                            value: "0"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("course.allStudent")), 1)
                            ]),
                            _: 1
                          }, 8, ["label"]),
                          _createVNode(_component_el_option, {
                            label: _ctx.t('course.specificStudent'),
                            value: "1"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t("course.specificStudent")), 1)
                            ]),
                            _: 1
                          }, 8, ["label"])
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                (_ctx.spec == '1')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                      _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.t("course.students")), 1),
                      _createVNode(_component_el_form_item, { prop: "students" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            modelValue: _ctx.course.students,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.course.students) = $event)),
                            multiple: "",
                            placeholder: _ctx.t('course.chooseStudents'),
                            as: "select"
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.studentList, (student) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: student._id,
                                  label: student.firstName + ' ' + student.lastName,
                                  value: student._id
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(student.firstName + " " + student.lastName), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "placeholder"]),
                          _createVNode(_component_Field, {
                            type: "hidden",
                            modelValue: _ctx.course.students,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.course.students) = $event)),
                            name: "students"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_26, [
                        _createElementVNode("div", _hoisted_27, [
                          _createVNode(_component_ErrorMessage, { name: "students" })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.t("course.description")), 1),
                _createVNode(_component_vue_editor, {
                  modelValue: _ctx.course.desc,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.course.desc) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createElementVNode("div", _hoisted_31, [
                  _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.t("course.resources")), 1),
                  _createVNode(_component_el_upload, {
                    action: "#",
                    accept: "image/*,.jpeg,.txt,.pdf,.docx,.doc,.pptx,.ppt,.xlsx,.xlsm,.xlsb,.xltx,.mp4,.avi,.mkv,.mp3",
                    class: "w-100 p-3 align-middle",
                    drag: "",
                    multiple: "",
                    "on-change": _ctx.updateUploadFiles,
                    "on-remove": _ctx.updateUploadFiles,
                    "list-type": "text",
                    "auto-upload": false,
                    limit: 15,
                    "on-exceed": _ctx.handleExceed
                  }, {
                    tip: _withCtx(() => [
                      _createElementVNode("div", _hoisted_35, [
                        _withDirectives(_createVNode(_component_el_progress, {
                          percentage: _ctx.uploadPercentage,
                          color: _ctx.customColorMethod
                        }, null, 8, ["percentage", "color"]), [
                          [_vShow, _ctx.uploadPercentage != 0]
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.t("course.fileSize")), 1)
                      ])
                    ]),
                    default: _withCtx(() => [
                      _hoisted_33,
                      _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.t("course.drobFiles")), 1)
                    ]),
                    _: 1
                  }, 8, ["on-change", "on-remove", "on-exceed"])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_36, [
            _createVNode(_component_router_link, {
              to: `/classe/${_ctx.classID}/cours`,
              id: "kt_modal_new_address_cancel",
              class: "btn btn-white me-3"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.t("course.cancel")), 1)
              ]),
              _: 1
            }, 8, ["to"]),
            _createElementVNode("button", _hoisted_37, [
              _createElementVNode("span", _hoisted_38, _toDisplayString(_ctx.t("course.add")), 1),
              _createElementVNode("span", _hoisted_39, [
                _createTextVNode(_toDisplayString(_ctx.t("pleaseWait")) + " ", 1),
                _hoisted_40
              ])
            ], 512)
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ], 2))
}